import { render } from "./EmployeeLanguages.vue?vue&type=template&id=a7f18acc"
import script from "./EmployeeLanguages.vue?vue&type=script&lang=js"
export * from "./EmployeeLanguages.vue?vue&type=script&lang=js"

import exportComponent from "/Users/thabangteddy/Downloads/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__